module.exports = __webpack_public_path__ + "cv.svg?0b63fdcac9f8337b4e84d7666619caae";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cv.svg
// module id = 785
// module chunks = 27